// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__10K9x","options":"AnswerScale_options__118cw","selected":"AnswerScale_selected__o-OKK"};